module.exports = __webpack_public_path__ + "img/emoji_73.98019fc2.png";